import Vue from 'vue'
 
// As a plugin
import VueMask from 'v-mask'
Vue.use(VueMask);